import React, { ReactElement } from 'react'
import { Box, Image } from '@mindfulchefuk/design-system'
import { RecipeCardClaims } from '@mindfulchefuk/features/Recipes/components/RecipeCardWithClaims/RecipeCardClaims/RecipeCardClaims'
import { TRecipeClaim } from '@mindfulchefuk/features/Recipes/interfaces'

export type TRecipeCardWithClaimsImage = {
  claims?: TRecipeClaim[]
  imgAltText: string
  imgUrl: string
  productId: string
  productName: string
}

export const RecipeCardWithClaimsImage = ({
  claims,
  imgAltText,
  imgUrl,
  productId,
  productName,
}: TRecipeCardWithClaimsImage): ReactElement => {
  return (
    <Box position="relative">
      {claims && (
        <RecipeCardClaims
          claims={claims}
          productId={productId}
          productName={productName}
        />
      )}
      <Image
        src={imgUrl}
        alt={imgAltText}
        width={380}
        height={253}
        loading="eager"
        useFallback
      />
    </Box>
  )
}
